export default __webpack_public_path__ + "static/media/git-plain.45ffb8cc.svg";